export const GET_REPORT_BY_BEATS_LIST_START = "GET_REPORT_BY_BEATS_LIST_START";
export const GET_REPORT_BY_BEATS_LIST_SUCCESS = "GET_REPORT_BY_BEATS_LIST_SUCCESS";
export const GET_REPORT_BY_BEATS_LIST_FAILURE = "GET_REPORT_BY_BEATS_LIST_FAILURE";

export const SEARCH_REPORT_BEAT_NAME = "SEARCH_REPORT_BEAT_NAME";

export const YEARLY_BEATS_LIST_START = "YEARLY_BEATS_LIST_START";
export const YEARLY_BEATS_LIST_SUCCESS = "YEARLY_BEATS_LIST_SUCCESS";
export const YEARLY_BEATS_LIST_FAILURE = "YEARLY_BEATS_LIST_FAILURE";